import { render, staticRenderFns } from "./Userjx.vue?vue&type=template&id=1c8179c4&scoped=true"
import script from "./Userjx.vue?vue&type=script&lang=js"
export * from "./Userjx.vue?vue&type=script&lang=js"
import style0 from "./Userjx.vue?vue&type=style&index=0&id=1c8179c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8179c4",
  null
  
)

export default component.exports